import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Tv',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("polygon", {
        attrs: { points: "9,10 9,18 16,14" }
      }), h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" }
        },
        [h("path", {
          attrs: { d: "M21.5 21.5h-19c-.6 0-1-.4-1-1v-13c0-.6.4-1 1-1h19c.6 0 1 .4 1 1v13c0 .6-.4 1-1 1z" }
        }), h("path", {
          attrs: { d: "M19.5 19.5h-15c-.6 0-1-.5-1-1v-9c0-.6.5-1 1-1h15c.6 0 1 .5 1 1v9c0 .5-.5 1-1 1z" }
        }), h("polyline", {
          attrs: { points: "7.5,2.5 12,6.5 16.5,2.5" }
        })]
      )]
    );
  }
};